'use client'

import { captureEvent } from '@/lib/analytics'

import { Button } from '@/components/Button'

function ArrowDownIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M4.75 8.75 8 12.25m0 0 3.25-3.5M8 12.25v-8.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function trackCvDownload() {
  captureEvent('cv_download', {
    source: 'resume_section',
    timestamp: new Date().toISOString(),
  })
}

export function DownloadCVButton() {
  return (
    <Button
      href="/Arne Noori Resume.pdf"
      variant="secondary"
      className="group mt-6 w-full"
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackCvDownload}
    >
      Download CV
      <ArrowDownIcon className="ease-out-strong size-4 stroke-zinc-400 transition duration-200 group-hover:translate-y-0.5 group-active:translate-y-1 group-active:stroke-zinc-600 dark:group-hover:stroke-zinc-50 dark:group-active:stroke-zinc-50" />
    </Button>
  )
}
